<template>
    <SeoScript v-if="Object.keys(inforSpace).length > 0" :infoSpace="inforSpace" :description="'緑溢れる開放的な空間で、思い出に残る特別な時間を…'" />
    <header>
    <section class="lp-gps__group" :class="{ 'lp-gps__group-scroll': isScroll }">
      <div class="lp-gps__group__left">
        <p :class="{ 'text-matcha': isScroll && !isShowReservation }">
          TEL.<a class="text-base" href="tel:03-6800-8931">03-6800-8931</a>
        </p>
      </div>
      <div class="lp-gps__group__right">
        <button @click="handleClickReservation" class="lp-gps__group__right-reservation">
          <img v-if="!isShowReservation" :src="calendarSvg" alt="calender icon" />
          <img v-if="isShowReservation" :src="close2" alt="close icon" />
          <p>{{ isShowReservation ? "CLOSE" : "ご予約" }}</p>
        </button>
        <nav @click="handleClickMenu" class="lp-gps__group__right-menu">
          <img :src="navbarSvg" alt="navi icon" class="pc-block" />
          <img :src="isShowNavbar ? navClose : navbarSpSvg" :alt="isShowNavbar ? `close icon` : `navi icon`"
            class="sp-block" />
          <p>MENU</p>
        </nav>
      </div>
      <div class="reservation-menu" :class="{ 'reservation-menu-show': isShowReservation }">
        <div>
          <p class="reservation-menu__title">
            RESERVATION<br class="sp-block" />
            &<br class="sp-block" />
            CONTACT
          </p>
          <p class="reservation-menu__sub-title">ご予約・お問合せ</p>
        </div>
        <div class="w-full flex items-center flex-col">
          <router-link :to="ROUTER_PATH.SPACE_BOOKING_CALENDAR_NEW + '/' + displayId"
            class="reservation-menu__book-room">
            <p>予約する<br /><span>(空室状況を確認する)</span></p>
            <img :src="chevronRightOrange" alt="arrow icon" />
          </router-link>
          <a @click.prevent="handleShowModalMenu()" href="reservation icon" class="reservation-menu__book-tour">
            <p>見学予約・問い合わせる</p>
            <img :src="chevronRightWhite" alt="arrow icon" />
          </a>
        </div>
        <div class="reservation-menu__group-text">
          <p>
            無料内見も可能！<br />
            ケータリングプランなど個別相談も承っております！
          </p>
          <p>TEL.<a href="tel:03-6800-8931">03-6800-8931</a></p>
          <p>営業時間&emsp;10:00～18：00（年末年始を除く）</p>
        </div>
      </div>

      <div class="nav-menu" :class="{ 'nav-menu-show': isShowNavbar }">
        <ul>
          <li v-for="(i, index) in navItem" :key="i">
            <a :href="i.href" @click="handleClickNavItem" class="">
              <p>{{ i.title }}</p>
              <img :src="index === navItem.length - 1
                ? chevronRightBlue
                : chevronRightMatcha
                " alt="arrow icon" />
            </a>
          </li>
        </ul>

        <div class="nav-menu__col">
          <div>
            <p class="nav-menu__title">
              RESERVATION<br class="sp-block" />
              &<br class="sp-block" />
              CONTACT
            </p>
            <p class="nav-menu__sub-title">ご予約・お問合せ</p>
          </div>

          <div class="w-full">
            <router-link :to="ROUTER_PATH.SPACE_BOOKING_CALENDAR_NEW + '/' + displayId" class="nav-menu__book-room">
              <p>予約する<br /><span>(空室状況を確認する)</span></p>
              <img :src="chevronRightWhite" alt="arrow icon" />
            </router-link>
            <a @click.prevent="handleShowModalMenu()" href="" class="nav-menu__book-tour">
              <p>見学予約・問い合わせる</p>
              <img :src="chevronRightOrange" alt="arrow icon" />
            </a>
          </div>
        </div>

        <div class="nav-menu__text-sp">
          <p>
            無料内見も可能！ ケータリングプランなど個別相談も承っております！
          </p>
          <p>TEL.<a href="tel:03-6800-8931">03-6800-8931</a></p>
          <p>営業時間&emsp;10:00～18：00（年末年始を除く）</p>
        </div>
      </div>
    </section>
  </header>
  <div class="lp-gps">
    <div class="lp-gps__banner">
      <Carousel class="lp-gps__carousel" :mouse-drag="false" :touch-drag="false">
        <Slide v-for="(item, index) in dataTopMovie" :key="index" class="lp-gps__carousel__slide">
          <picture>
            <source media="(max-width:767px)" :srcset="ImageResizing(item.img_mobile, '20')" />
            <img :src="ImageResizing(item.img_pc, '20')" alt="グレイドパーク新宿 大広間" class="lp-gps__carousel__item" />
          </picture>
        </Slide>
      </Carousel>

      <img class="lp-gps__banner-logo-absolute" :src=logo alt="logo">

      <div class="lp-gps__banner-title-absolute">
        <h1>
          <span>新宿のパーティー会場・宴会場・貸切会場</span><br />
          <span>グレイドパーク新宿</span>
        </h1>
      </div>
    </div>

    <section class="lp-gps__concept">
      <div class="lp-gps__concept__block">
        <p>Concept</p>
        <h2>グレイドパーク新宿の特徴・コンセプト</h2>
        <p>
          緑溢れる開放的な空間で、<br />
          思い出に残る特別な時間を…
        </p>
        <p>
          ヒルトン東京の地下1Fに生まれた、緑溢れる公園のようなイベント会場。<br />
          ステージや演出機材なども完備し、パーティや各種イベント、セミナーを開催いただけます。<br /><br />
          東京メトロ丸ノ内線 西新宿駅 2番出口2分<br />
          最大収容 120人<br />
          全体面積 272.76㎡<br /><br />
          グレイドパーク新宿は、西新宿駅徒歩2分の好立地で最大収容人数120人のパーティー会場・宴会場・貸切会場です。<br />
          周年パーティー・結婚式二次会・大人数イベントの会場としてのご利用はもちろん、セミナー、撮影会、展示会などにもご利用いただけます。<br />
          お客様のご要望に合わせたカスタマイズプランもご提供可能です。
        </p>
      </div>
    </section>

    <section class="lp-gps__photo-gallery justify-start" id="gallery">
      <div class="lp-gps__photo-gallery__wrapper">
        <p class="title-en">Photo Gallery</p>
        <div class="title-jp">
          <h2>グレイドパーク新宿の内装ギャラリー</h2>
          <p>－グレイドパーク新宿の内装と雰囲気をご紹介いたします</p>
        </div>
        <div class="lp-gps__photo-gallery__box-carousel">
          <Carousel class="lp-gps__photo-gallery__carousel" :breakpoints="galeryBreakpoints" :wrap-around="true"
            :autoplay="5000" :model-value="0">
            <Slide v-for="(item, index) in inforSpace?.image" :key="`gallery-${index}`"
              @click="handleShowGallery(item.id)" class="lp-gps__carousel__slide">
              <img :src="ImageResizing(item.path_image, 20, true)" :alt="`グレイドパーク新宿 gallery-${index}`"
                class="lp-gps__carousel__item" />
            </Slide>
            <template #addons>
              <Navigation class="lp-gps__photo-gallery__group-arrow">
                <template #next>
                  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                    <path
                      d="M0 15C0 6.71601 6.71602 0 15 0C23.284 0 30 6.71601 30 15C30 23.284 23.284 30 15 30C6.71602 30 0 23.284 0 15ZM14.1211 7.91016C13.5703 7.35938 12.6797 7.35938 12.1348 7.91016C11.5898 8.46094 11.584 9.35156 12.1348 9.89648L17.2324 14.9941L12.1348 20.0918C11.584 20.6426 11.584 21.5332 12.1348 22.0781C12.6855 22.623 13.5762 22.6289 14.1211 22.0781L20.2148 15.9961C20.7656 15.4453 20.7656 14.5547 20.2148 14.0098L14.1211 7.91016Z"
                      fill="white" />
                  </svg>
                </template>
                <template #prev>
                  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                    <path
                      d="M30 15C30 23.284 23.284 30 15 30C6.71601 30 0 23.284 0 15C0 6.71602 6.71601 0 15 0C23.284 0 30 6.71602 30 15ZM15.8789 22.0898C16.4297 22.6406 17.3203 22.6406 17.8652 22.0898C18.4102 21.5391 18.416 20.6484 17.8652 20.1035L12.7676 15.0059L17.8652 9.9082C18.416 9.35742 18.416 8.4668 17.8652 7.92188C17.3145 7.37695 16.4238 7.37109 15.8789 7.92188L9.78516 14.0039C9.23438 14.5547 9.23438 15.4453 9.78516 15.9902L15.8789 22.0898Z"
                      fill="white" />
                  </svg>
                </template>
              </Navigation>
              <Pagination />
            </template>
          </Carousel>
        </div>
      </div>
    </section>

    <section class="lp-gps__glade-park" id="price">
      <div class="lp-gps__glade-park-wrapper">
        <div class="title">
          <h2>グレイドパーク新宿の<br class="pc-block" />料金プラン</h2>
          <p class="pc-block lp-gps__glade-park-title">Glade<br />Park<br />Shinjuku</p>
        </div>
        <p class="sp-block lp-gps__glade-park-title">Glade Park Shinjuku</p>
        <div class="lp-gps__glade-park-img">
          <img :src="ImageResizing(Img002, '20')" alt="Glade Park Shinjuku space image1" />
          <img :src="ImageResizing(Img003, '20')" alt="Glade Park Shinjuku space image2" />
        </div>
        <div class="lp-gps__glade-park-parameter">
          <p class="lp-gps__glade-park-pice">
            ￥
            <span>
              {{
                Math.floor(
                  Number(inforSpace?.minimum_tenancy_price || 0) * 1.1
                ).toLocaleString()
              }}
            </span>
            <span>～</span>/1H
          </p>
          <router-link :to="ROUTER_PATH.DETAIL + '/' + displayId">
            <p>もっと詳しく見る</p>
            <img :src="sectionStyleChevron" alt="more" />
          </router-link>
        </div>
      </div>
    </section>

    <section class="lp-gps__section-style" id="type-use">
      <div class="lp-gps__section-style__style">
        <div class="title">
          <h2>
            グレイドパーク新宿の<br class="sp-block" />ご利用用途例
          </h2>
          <p>Style</p>
        </div>
        <div class="pc-block">
          <div class="lp-gps__section-style__style-list">
            <img :src="ImageResizing(Img004, '20')" alt="party drink" />
            <img :src="ImageResizing(Img005, '20')" alt="wedding image" />
            <img :src="ImageResizing(Img006, '20')" alt="party cheers" />
          </div>
        </div>
        <div class="sp-block">
          <Carousel class="lp-gps_reason_carousel" :wrap-around="true" :mouse-drag="true" :touch-drag="true"
            :autoplay="4000" :breakpoints="carouselBreakpoints" style="
                display: flex;
                flex-direction: column;
                align-items: center;
            ">
            <Slide class="lp-gps_reason_carosel_slide" style="padding-right: 0;">
              <img :src="ImageResizing(Img004, '20')" alt="party drink" />
            </Slide>
            <Slide class="lp-gps_reason_carosel_slide" style="padding-right: 0;">
              <img :src="ImageResizing(Img005, '20')" alt="wedding image" />
            </Slide>
            <Slide class="lp-gps_reason_carosel_slide" style="padding-right: 0;">
              <img :src="ImageResizing(Img006, '20')" alt="party cheers" />
            </Slide>
          </Carousel>
        </div>
      </div>

      <div class="lp-gps__section-style__live-event">
        <div class="lp-gps__section-style__live-event-wrapper">
          <div class="lp-gps__section-style__live-event-left">
            <p class="lp-gps__section-style__live-event-title pc-block">
              Event Style
            </p>
            <h3>50名〜120名規模のイベントに</h3>
            <p>
              グレイドパーク新宿は、50名から120名規模のイベントにぴったりのパーティー会場です。
              広々とした宴会場は、ビジネスイベントやプライベートパーティーに最適、参加者が快適に過ごせる環境を提供します。
              西新宿駅徒歩2分の好立地で集客しやすく、設備・備品も充実、控室・クロークもあります。追加マイクや早朝・深夜対応オプションで 幅広い用途で利用可能です。
            </p>
          </div>

          <div class="lp-gps__section-style__live-event-block-img">
            <img :src="ImageResizing(Img008, '20')" alt="party image1" />
            <img :src="ImageResizing(Img009, '20')" alt="party image2" />
          </div>

          <div class="lp-gps__section-style__live-event-right">
            <img :src="ImageResizing(Img001, '20')" alt="space image" class="pc-block" />
            <img :src="ImageResizing(Img001SP, '20')" alt="space image" class="sp-block" />
          </div>
          <p class="lp-gps__section-style__live-event-title sp-block">
            Event Style
          </p>
        </div>
      </div>

      <div class="lp-gps__section-style__party">
        <div class="lp-gps__section-style__party-wrapper">
          <div class="lp-gps__section-style__party-left">
            <img :src="ImageResizing(Img010, '20')" alt="party mono" class="pc-block" />
            <img :src="ImageResizing(Img011, '20')" alt="party" class="pc-block" />
            <img :src="ImageResizing(Img010SP, '20')" alt="party mono" class="sp-block" />
            <img :src="ImageResizing(Img011SP, '20')" alt="party" class="sp-block" />
          </div>
          <div class="lp-gps__section-style__party-right">
            <p>Party Style</p>
            <h3>パーティー・オフ会・交流会</h3>
            <p>
              パーティーやオフ会、交流会を開催するなら、グレイドパーク新宿のイベント会場が最適です。多様なレイアウトが可能な宴会場は、参加者同士の距離を縮めるための理想的な空間です。100人以上での、飲食あり貸切パーティが可能です。
            </p>
          </div>
        </div>
      </div>

      <div class="lp-gps__section-style__wedding">
        <div class="lp-gps__section-style__wedding-wrapper">
          <p class="lp-gps__section-style__wedding-title-sp">Wedding</p>
          <div class="lp-gps__section-style__wedding-left">
            <img :src="ImageResizing(Img012, '20')" alt="drink image" />
            <img :src="ImageResizing(Img012SP, '20')" alt="drink image" />
            <img :src="ImageResizing(Img013, '20')" alt="wedding image" />
          </div>

          <div class="lp-gps__section-style__wedding-right">
            <p>Wedding</p>
            <h3>結婚式2次会</h3>
            <p>
              グレイドパーク新宿は、結婚式の2次会にも利用できるパーティー会場です。広々とした宴会場は、50名から120名までのゲストを収容でき、アットホームな雰囲気を演出します。西新宿駅から徒歩2分の好立地でゲストも迷うことなく来店可能。控室・クロークやステージあり、予算に合わせて料理もカスタマイズでき、自由なレイアウトで思い出に残る結婚式2次会を実現できます。
            </p>
          </div>
        </div>
      </div>

      <div class="lp-gps__section-style__group-party">
        <div class="lp-gps__section-style__group-party-wrapper">
          <p class="lp-gps__section-style__group-party-title sp-block">Group Party</p>
          <div class="lp-gps__section-style__group-party-left">
            <img :src="ImageResizing(Img014, '20')" alt="party image" class="pc-block" />
            <img :src="ImageResizing(Img027, '20')" alt="party image" class="sp-block" />
          </div>

          <div class="lp-gps__section-style__group-party-block-img">
            <img :src="ImageResizing(Img015, '20')" alt="cartring" />
            <img :src="ImageResizing(Img016, '20')" alt="cheers image" />
          </div>

          <div class="lp-gps__section-style__group-party-right">
            <p class="lp-gps__section-style__group-party-title pc-block">Group Party</p>
            <h3>歓送迎会・懇親会・謝恩会・同窓会</h3>
            <p>
              歓送迎会や懇親会、謝恩会、同窓会など、会社の同僚、友人・知人など気のあう仲間とのパーティーにご利用ください。ケータリングを利用してパーティーを行える宴会場として利用可能で、参加者同士の交流を深めるのに最適な空間にできます。さまざまなイベントに対応できるグレイドパーク新宿は、アクセスも良好、特別な装飾やテーマに合わせたセッティングができます。
            </p>
          </div>
        </div>
      </div>

      <div class="lp-gps__section-style__seminar">
        <div class="lp-gps__section-style__seminar-wrapper">
          <div class="lp-gps__section-style__seminar-right">
            <p>Seminar</p>
            <h3>セミナー・展示会</h3>
            <p>
              セミナーや展示会を開催する際には、グレイドパーク新宿のイベント会場が最適です。セミナーで使えるステージやプロジェクターなどの充実した設備と、展示会に合わせたレイアウトに変更することもできます。セミナーや展示会の後には、アフターパーティーも開催できます。
            </p>
          </div>
          <div class="lp-gps__section-style__seminar-left">
            <img :src="ImageResizing(Img018, '20')" alt="space mono" />
            <img :src="ImageResizing(Img017, '20')" alt="space" />
          </div>
        </div>
      </div>

      <div class="lp-gps__section-style__photograph">
        <div class="lp-gps__section-style__photograph-wrapper">
          <p class="lp-gps__section-style__photograph-title-sp">Photograph</p>
          <div class="lp-gps__section-style__photograph-left">
            <img :src="ImageResizing(Img019, '20')" alt="space mono" />
            <img :src="ImageResizing(Img020, '20')" alt="photograph" />
          </div>
          <div class="lp-gps__section-style__photograph-left-sp">
            <img :src="ImageResizing(Img020SP, '20')" alt="photograph" />
          </div>

          <div class="lp-gps__section-style__photograph-right">
            <img :src="ImageResizing(Img021, '20')" alt="camera" />
          </div>
          <div class="lp-gps__section-style__photograph-right-sp">
            <img :src="ImageResizing(Img019SP, '20')" alt="space mono" />
            <img :src="ImageResizing(Img021SP, '20')" alt="camera" />
          </div>

          <div class="lp-gps__section-style__photograph-text">
            <p class="pc-block">Photograph</p>
            <h3 class="pc-block">撮影会・TV収録・ロケ撮影・記者会見</h3>
            <p class="pc-block">
              グレイドパーク新宿は、撮影会やTV収録、ロケ撮影、記者会見など、さまざまなメディア関連のイベントにも対応可能なパーティー会場です。広々とした会場は、撮影に適した明るさと広さを兼ね備えており、ムービングライトなど本格的な照明もあります。パーティーなどの宴会場としての利用だけでなく撮影や収録などにもご利用いただけます。
            </p>
            <h3 class="sp-block text-center">撮影会・TV収録・ロケ撮影<br />記者会見</h3>
            <p class="sp-block">
              グレイドパーク新宿は、撮影会やTV収録、ロケ撮影、記者会見など、さまざまなメディア関連のイベントにも対応可能なパーティー会場です。広々とした会場は、撮影に適した明るさと広さを兼ね備えており、ムービングライトなど本格的な照明もあります。パーティーなどの宴会場としての利用だけでなく撮影や収録などにもご利用いただけます。
            </p>
          </div>
        </div>
      </div>
    </section>
    <div class="lp-gps_reason" id="reason">
      <div class="lp-gps_reason_container">
        <div class="lp-gps_reason_header">
          <p class="lp-gps_reason_title">Reason</p>
          <div class="lp-gps_reason_sub-title">
            <h2>グレイドパーク新宿がお客様に選ばれる理由</h2>
          </div>
        </div>
        <Carousel class="lp-gps_reason_carosel" :wrap-around="true" :mouse-drag="true" :touch-drag="true"
          :autoplay="5000" :breakpoints="carouselBreakpoints">
          <Slide class="lp-gps_reason_carosel_slide">
            <div class="lp-gps_reason_carosel_slide_img">
              <img :src="ImageResizing(Img023, '20')" alt="reason image1" />
            </div>
            <h3 href="javascript:void(0)" class="lp-gps_reason_carosel_slide_title">
              01.立地が良い
            </h3>
            <p class="lp-gps_reason_carosel_slide_des">
              東京メトロ丸ノ内線西新宿駅2番出口より徒歩2分のアクセスの良さが「グレイドパーク新宿（Glade
              Park 新宿）」が選ばれている理由の1つです。<br />
              ヒルトン東京の地下1F内となります。
            </p>
          </Slide>
          <Slide class="lp-gps_reason_carosel_slide">
            <div class="lp-gps_reason_carosel_slide_img">
              <img :src="ImageResizing(Img024, '20')" alt="reason image2" />
            </div>
            <h3 class="lp-gps_reason_carosel_slide_title">
              02.貸切OK、幅広い利用用途
            </h3>
            <p class="lp-gps_reason_carosel_slide_des">
              新宿で最大120名収容可能、大型イベントを開催可能！<br />
              着席最大56名、立食最大120名の収容が可能で、さまざまなレイアウト変更に対応いたします。<br />
              結婚式2次会、各種イベント・パーティ、展示会などの幅広い用途でご利用いただけます。
            </p>
          </Slide>
          <Slide class="lp-gps_reason_carosel_slide">
            <div class="lp-gps_reason_carosel_slide_img">
              <img :src="ImageResizing(Img025, '20')" alt="reason image3" />
            </div>
            <h3 class="lp-gps_reason_carosel_slide_title">
              03.設備・備品、オプションが充実
            </h3>
            <p class="lp-gps_reason_carosel_slide_des">
              音響、プロジェクターなど、イベントに必須な設備・備品が充実しています。<br />
              控室や追加のマイクなど、有料オプションが充実しているので有料オプションのお申込でイベントの幅が広がります。
            </p>
          </Slide>
          <Slide class="lp-gps_reason_carosel_slide">
            <div class="lp-gps_reason_carosel_slide_img">
              <img :src="ImageResizing(Img026, '20')" alt="reason image4" />
            </div>
            <h3 class="lp-gps_reason_carosel_slide_title">
              04.無料内見サービス
            </h3>
            <p class="lp-gps_reason_carosel_slide_des">
              事前にスペースを確認できる無料内見サービスをご提供しています。<br />
              レイアウトやスペースの雰囲気を確認してからご予約ができる、無料内見サービスが可能な点が選ばれている理由の一つです。
            </p>
          </Slide>
          <template #addons>
            <Navigation />
            <Pagination />
          </template>
        </Carousel>
      </div>
    </div>
    <div class="lp-gps_plan" id="serve">
      <div class="lp-gps_plan_header">
        <div class="lp-gps_plan_header-bot">
          <div class="lp-gps_plan_header-bot_left">
            <img :src="ImageResizing(imgPlan1, '20')" alt="plan image1" class="lp-gps_plan_header-bot_left_img-left" />
            <img :src="ImageResizing(imgPlan2, '20')" alt="plan image2" class="lp-gps_plan_header-bot_left_img-right" />
          </div>
          <div class="lp-gps_plan_header-bot_right">
            <div class="lp-gps_plan_header-top">
              <p>Customize Plan</p>
            </div>
            <h2>食事メニューやプランのカスタマイズ</h2>
            <p class="lp-gps_plan_header-bot_right_content">
              スペースをご利用いただくお客様のご要望でお食事メニューやプランをご用意いたします。<br />
              お気軽にご相談ください。
            </p>
            <a @click.prevent="handleShowModalDetail" href="#" class="lp-gps_plan_header-bot_right_button">
              問い合わせる
              <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                <path
                  d="M0.85498 10.5C0.85498 4.97734 5.33232 0.5 10.855 0.5C16.3776 0.5 20.855 4.97734 20.855 10.5C20.855 16.0227 16.3776 20.5 10.855 20.5C5.33232 20.5 0.85498 16.0227 0.85498 10.5ZM10.269 5.77344C9.90186 5.40625 9.30811 5.40625 8.94482 5.77344C8.58154 6.14063 8.57764 6.73438 8.94482 7.09766L12.3433 10.4961L8.94482 13.8945C8.57764 14.2617 8.57764 14.8555 8.94482 15.2188C9.31201 15.582 9.90576 15.5859 10.269 15.2188L14.3315 11.1641C14.6987 10.7969 14.6987 10.2031 14.3315 9.83984L10.269 5.77344Z"
                  fill="white" />
              </svg>
            </a>
          </div>
        </div>
      </div>
      <div class="lp-gps_plan_list">
        <p class="lp-gps_plan_list_title">Plan Example</p>
        <h3 class="lp-gps_plan_list_sub-title">グレイドパーク新宿のお食事プラン例</h3>
        <Carousel class="lp-gps_plan_carosel" :mouse-drag="true" :touch-drag="true" :wrap-around="true" :autoplay="5000"
          :breakpoints="planBreakpoints">
          <Slide class="lp-gps_plan_carosel_slide" v-for="(item, index) in dataCatering?.plan"
            :key="`plan-item-${index}`">
            <div class="plan-item-container">
              <div class="lp-gps_plan_carosel_slide_img">
                <img :src="ImageResizing(item?.image, 20, true)" :alt="`catering image ${index}`" />
              </div>
              <div class="lp-gps_plan_carosel_slide_content">
                <div class="lp-gps_plan_carosel_slide_promotion" v-if="item.refill_drink === 1">
                  <p>2時間飲み放題付</p>
                </div>
                <div class="lp-gps_plan_carosel_slide_content-top min-h-unset">
                  <p class="lp-gps_plan_carosel_slide_content-level">
                    {{ item?.title_en }}
                  </p>
                  <h4 class="lp-gps_plan_carosel_slide_content-title">
                    {{ item?.title_ja }}（{{ item.number_of_item + item.type_of_item }}）
                  </h4>
                </div>
                <div class="lp-gps_plan_carosel_slide_content-bot">
                  <p class="lp-gps_plan_carosel_slide_price-tag">価 格</p>
                  <div>
                    <p class="lp-gps_plan_carosel_slide_price-text">
                      <span>{{
                        Math.floor(Number(item?.price)).toLocaleString(
                        "en-US"
                        )
                        }}円</span>（税込）/人
                    </p>
                  </div>
                </div>
                <div class="lp-gps_plan_carosel_slide_link">
                  <button @click="openModalPlan(item.id)">
                    <p>詳しくはこちら</p>
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                      <path
                        d="M0.5 10C0.5 4.47734 4.97734 0 10.5 0C16.0227 0 20.5 4.47734 20.5 10C20.5 15.5227 16.0227 20 10.5 20C4.97734 20 0.5 15.5227 0.5 10ZM9.91406 5.27344C9.54688 4.90625 8.95313 4.90625 8.58984 5.27344C8.22656 5.64063 8.22266 6.23438 8.58984 6.59766L11.9883 9.99609L8.58984 13.3945C8.22266 13.7617 8.22266 14.3555 8.58984 14.7188C8.95703 15.082 9.55078 15.0859 9.91406 14.7188L13.9766 10.6641C14.3438 10.2969 14.3438 9.70313 13.9766 9.33984L9.91406 5.27344Z"
                        fill="#7D987D" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </Slide>
          <template #addons>
            <Navigation />
            <Pagination />
          </template>
        </Carousel>
      </div>
    </div>
    <section class="p-modal" :class="{ open: isShowModalPlan && currentModalId === plan.id }"
      v-for="(plan, index) in dataCatering?.plan" :key="index">
      <div class="p-modal_overlay" @click="closeModalPlan"></div>
      <div class="p-modal_body">
        <div class="p-modal_bg">
          <div class="p-modal_close" @click="closeModalPlan">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <rect width="24" height="24" fill="#D9D9D9" />
              <path
                d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
                fill="black" />
            </svg>
          </div>
          <div class="p-modal_content">
            <div class="p-modal_content_img">
              <img :src="ImageResizing(plan.image, 20, true)" :alt="plan.title_ja + plan.title_en" />
            </div>
            <div class="p-modal_content_text">
              <div class="p-modal_content_decor" v-if="plan.refill_drink == 1">
                2時間飲み放題付
              </div>
              <div class="p-modal_content_top">
                <div class="p-modal_content_type">{{ plan.title_en }}</div>
                <div class="p-modal_content_title">{{ plan.title_ja }}（{{ plan.number_of_item + plan.type_of_item }}）
                </div>
              </div>
              <div class="p-modal_content_bot">
                <ul>
                  <li>{{ plan.menu }}</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="p-modal_button">
            <button @click.prevent="handleShowModalDetail">
              <p>問い合わせる</p>
              <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                <path
                  d="M0.5 10.093C0.5 4.57036 4.97734 0.0930176 10.5 0.0930176C16.0227 0.0930176 20.5 4.57036 20.5 10.093C20.5 15.6157 16.0227 20.093 10.5 20.093C4.97734 20.093 0.5 15.6157 0.5 10.093ZM9.91406 5.36646C9.54688 4.99927 8.95313 4.99927 8.58984 5.36646C8.22656 5.73364 8.22266 6.32739 8.58984 6.69067L11.9883 10.0891L8.58984 13.4875C8.22266 13.8547 8.22266 14.4485 8.58984 14.8118C8.95703 15.175 9.55078 15.179 9.91406 14.8118L13.9766 10.7571C14.3438 10.3899 14.3438 9.79614 13.9766 9.43286L9.91406 5.36646Z"
                  fill="white" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </section>
    <div class="lp-gps_access" id="access">
      <div class="lp-gps_access_container">
        <div class="lp-gps_access_header">
          <p class="lp-gps_access_title">ACCESS</p>
          <h2 class="lp-gps_access_sub-title">グレイドパーク新宿へのアクセス</h2>
        </div>
        <div class="lp-gps_access_content">
          <div class="lp-gps_access_content_left">
            <p class="lp-gps_access_content_left_title">
              東京メトロ丸ノ内線西新宿駅<br />
              2番出口より徒歩2分
            </p>
            <p class="lp-gps_access_content_left_des">
              東京メトロ丸ノ内線西新宿駅から徒歩2分。<br />
              改札を出て「ヒルトン東京」の案内矢印の方へ歩いていくと、地上に出ずに到着できます。
            </p>
            <div class="lp-gps_access_content_left_table">
              <div class="lp-gps_access_content_left_table_row">
                <h3 class="lp-gps_access_content_left_table_title">住所</h3>
                <div class="lp-gps_access_content_left_table_content tracking-[-0.3px] md:tracking-0">
                  〒160-0023<br />
                  東京都新宿区西新宿<br class="hidden md:block" />
                  6-6-2 新宿国際ビルディング地下1F
                </div>
              </div>
              <div class="lp-gps_access_content_left_table_row">
                <h3 class="lp-gps_access_content_left_table_title">最寄り駅</h3>
                <div class="lp-gps_access_content_left_table_content">
                  東京メトロ丸ノ内線 西新宿駅 ２番出口より徒歩 2分
                </div>
              </div>
              <div class="lp-gps_access_content_left_table_row">
                <h3 class="lp-gps_access_content_left_table_title">アクセス</h3>
                <div class="lp-gps_access_content_left_table_content">
                  ◆西新宿駅からのアクセス◆<br />
                  西新宿の改札を出て右斜め前【出口2】方面へ直進。一つ目の曲がり角を右折し、階段を降り、そのまま直進。<br />
                  右手【ヒルトン東京】の案内矢印の方へ、エスカレーターを上り直進。ヒルトピア入口自動ドアよりヒルトピア内に入り左折し、一つ目の曲がり角を右へ。突き当たり右手が「グレイドパーク新宿（Glade
                  Park 新宿）」 です。
                </div>
              </div>
            </div>
          </div>
          <div class="lp-gps_access_content_right">
            <img :src="ImageResizing(Img022, '20')" alt="グレイドパーク新宿 アクセス情報" />
          </div>
        </div>
      </div>
      <div class="lp-gps_access_map">
        <iframe v-bind:src="mapSrc" width="100%" height="550" style="border: 0" allowfullscreen="" loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"></iframe>
      </div>
    </div>
    <div class="lp-gps_overview" id="lp-overview">
      <div class="lp-gps_overview_container">
        <div class="lp-gps_overview_header">
          <p>Overview</p>
          <h2>グレイドパーク新宿の詳細・設備・備品</h2>
        </div>
        <div class="lp-gps__detail__table-wrapper">
          <table class="lp-gps__detail__table">
            <tbody>
              <tr>
                <td class="first-td">広さ</td>
                <td colspan="2">
                  <p>約 272.76㎡</p>
                </td>
              </tr>
              <tr>
                <td class="first-td">天井高</td>
                <td colspan="2">
                  <p>2500mm〜2700mm</p>
                </td>
              </tr>
              <tr>
                <td class="first-td">収容人数</td>
                <td colspan="2">
                  <p>着席最大56名</p>
                  <p>立食最大120名</p>
                </td>
              </tr>
              <tr>
                <td rowspan="5" class="first-td">
                  <p class="font-bold">
                    箱貸し料金<br />
                    （税込）
                  </p>
                </td>
              </tr>
              <tr>
                <td class="w-300 p-5">
                  <p>通常料金<br />(9〜22時)</p>
                </td>
                <td class="p-5">
                  26,290円〜/1h&emsp;<br class="sp-block" />※最低3h〜
                </td>
              </tr>
              <tr>
                <td class="w-300 p-5">控室</td>
                <td class="p-5">1,650円/枠 <br class="sp-block" />※30分/1枠</td>
              </tr>
              <tr></tr>
              <tr>
                <td>その他</td>
                <td>
                  <p>時間外の料金について</p>
                  <p>スペース料金：通常料金の2割増＋深夜対応費33,000円</p>
                </td>
              </tr>
              <tr>
                <td class="first-td">利用時間</td>
                <td colspan="2">
                  <p>9：00～22：00</p>
                  <p>※パーティー以外は24h営業にて要相談</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="lp-gps_nearby">
      <div class="lp-gps_nearby_container">
        <div class="lp-gps_nearby_header">
          <div class="lp-gps_nearby_title pc-block">
            <p class="mb[-20px] mr-[50px] text-[74px]">Venues</p>
            <p class="mb-[-60px] text-[74px]">nearby</p>
          </div>
          <div class="lp-gps_nearby_title sp-block">
            <p class="text-[30px]">Venues nearby</p>
          </div>
        </div>
        <div class="lp-gps_nearby_sub-title">
          <h2>グレイドパーク新宿に近い<br class="sp-block" />パーティー会場・宴会場・貸切会場</h2>
        </div>
        <Carousel class="lp-gps_nearby_carosel" :mouse-drag="true" :touch-drag="true" :wrap-around="true"
          :autoplay="5000" :breakpoints="planBreakpoints">
          <Slide class="lp-gps_nearby_carosel_slide" v-for="(spaceItem, index) in item" :key="spaceItem.id || index">
            <LPSpaceItemSmall :spaceInfo="spaceItem" :no="index" v-if="spaceItem" :pageCurrent="1" />
          </Slide>
          <template #addons>
            <Navigation />
            <Pagination />
          </template>
        </Carousel>
      </div>
    </div>
  </div>
  <div class="c-bus-breadcrumbs">
    <div class="c-bus-breadcrumbs_inner">
      <ul class="list">
        <li class="list-item" v-for="(item, index) in props.linkLst" :key="index">
          <span :class="item.link ? props.linkClass : 'not-hover'"
            @click="item.link ? handlePagelink(item.link) : null">
            {{ item.page_title }}
          </span>
        </li>
      </ul>
    </div>
  </div>

  <footer class="lp-gps__footer">
    <p>Copyright ©️ adval All Rights Reserved.</p>
  </footer>
  <v-dialog v-model="isShowModalSendMail" class="apply-action__box form-lp" hide-overlay scrollable>
    <FormDetail @handleCloseModalList="() => (isShowModalSendMail = false)"
      :nameSpace="inforSpace?.general?.general_basic_space_name_ja" :idSpace="idSpace"
      :webTourStatus="inforSpace?.web_tour_status" :classCustom="'lp-ebisu-room'" :contactCateringLp="true" />
  </v-dialog>

  <v-dialog v-model="isShowModalSendMailMenu" class="apply-action__box form-lp" hide-overlay scrollable>
    <FormDetail @handleCloseModalList="() => (isShowModalSendMailMenu = false)"
      :nameSpace="inforSpace?.general?.general_basic_space_name_ja" :idSpace="idSpace"
      :webTourStatus="inforSpace?.web_tour_status" :classCustom="'lp-ebisu-room'" />
  </v-dialog>

  <v-dialog v-model="isShowModalImg" class="apply-action__box popup_photo" hide-overlay scrollable>
    <PopUpListImage @handleShowModalImg="() => (isShowModalImg = false)" :inforSpace="inforSpace"
      :fristImageFacilityId="fristImageFacilityId" />
  </v-dialog>
</template>

<script setup>
/* eslint-disable */
import "../ForpartyGroup/forpartyGroupNew.scss";

import { ref, onMounted, inject, onUnmounted, watch } from "vue";
import { Carousel, Navigation, Pagination, Slide } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";
import PC_TOP_OPEN from "@/client/assets/images/LpShinjuku/top/top-pc.png";
import SP_TOP_OPEN from "@/client/assets/images/LpShinjuku/top/top-sp.png";
import PopUpListImage from "@/client/views/LpGradeParkShipuya/Modal/PopUpListImage.vue";
import FormDetail from "@/client/views/DetailSpace/child/FormDetail";
import LPSpaceItemSmall from "@/client/views/ForpartyGroup/OtherSpace/LPSpaceItemSmall.vue";

//New
import calendarSvg from "@/client/assets/images/LpGradeParkShipuya/calendar2.svg";
import navbarSvg from "@/client/assets/images/LpGradeParkShipuya/nav.svg";
import navbarSpSvg from "@/client/assets/images/LpGradeParkShipuya/nav-sp.svg";
import navClose from "@/client/assets/images/LpGradeParkShipuya/navClose.svg";
import chevronRightOrange from "@/client/assets/images/LpGradeParkShipuya/chevron-orange.svg";
import chevronRightWhite from "@/client/assets/images/LpGradeParkShipuya/chevron-white.svg";
import chevronRightMatcha from "@/client/assets/images/LpGradeParkShipuya/chevron-matcha.svg";
import chevronRightBlue from "@/client/assets/images/LpGradeParkShipuya/chevron-right-blue.svg";
import close2 from "@/client/assets/images/LpGradeParkShipuya/close2.svg";
import imgPlan1 from "@/client/assets/images/LpGradeParkShipuya/img-plan-1.png";
import imgPlan2 from "@/client/assets/images/LpGradeParkShipuya/img-plan-2.png";
import sectionStyleChevron from "@/client/assets/images/LpGradeParkShipuya/chevron-white.svg";

import Img001 from "@/client/assets/images/LpShinjuku/001.png";
import Img001SP from "@/client/assets/images/LpShinjuku/001SP.jpg";
import Img002 from "@/client/assets/images/LpShinjuku/002.png";
import Img003 from "@/client/assets/images/LpShinjuku/003.png";
import Img004 from "@/client/assets/images/LpShinjuku/004.png";
import Img005 from "@/client/assets/images/LpShinjuku/005.png";
import Img006 from "@/client/assets/images/LpShinjuku/006.png";
import Img008 from "@/client/assets/images/LpShinjuku/008.png";
import Img009 from "@/client/assets/images/LpShinjuku/009.png";
import Img010 from "@/client/assets/images/LpShinjuku/010.png";
import Img010SP from "@/client/assets/images/LpShinjuku/010SP.png";
import Img011 from "@/client/assets/images/LpShinjuku/011.png";
import Img011SP from "@/client/assets/images/LpShinjuku/011SP.png";
import Img012 from "@/client/assets/images/LpShinjuku/012.png";
import Img012SP from "@/client/assets/images/LpShinjuku/012SP.png";
import Img013 from "@/client/assets/images/LpShinjuku/013.png";
import Img014 from "@/client/assets/images/LpShinjuku/014.png";
import Img015 from "@/client/assets/images/LpShinjuku/015.png";
import Img016 from "@/client/assets/images/LpShinjuku/016.png";
import Img017 from "@/client/assets/images/LpShinjuku/017.png";
import Img018 from "@/client/assets/images/LpShinjuku/018.png";
import Img019 from "@/client/assets/images/LpShinjuku/019.png";
import Img020 from "@/client/assets/images/LpShinjuku/020.png";
import Img021 from "@/client/assets/images/LpShinjuku/021.png";
import Img019SP from "@/client/assets/images/LpShinjuku/019SP.png";
import Img020SP from "@/client/assets/images/LpShinjuku/020SP.png";
import Img021SP from "@/client/assets/images/LpShinjuku/021SP.png";
import Img022 from "@/client/assets/images/LpShinjuku/022.png";
import Img023 from "@/client/assets/images/LpShinjuku/023.png";
import Img024 from "@/client/assets/images/LpShinjuku/024.png";
import Img025 from "@/client/assets/images/LpShinjuku/025.png";
import Img026 from "@/client/assets/images/LpShinjuku/026.png";
import Img027 from "@/client/assets/images/LpShinjuku/027.png";

import logo from "@/client/assets/images/LpGladePark/logo.png";

import useStore from "@/admin/store/adminSpace";
import { ROUTER_PATH } from "@/client/const";
import {
  getSpaceInfoByDisplayIdApi,
  getListDetailSpaceApi,
  getCateringDetail,
  getListSpaceByLocationApi
} from "@/client/api";
import { ImageResizing } from "@/client/utils";

import { defineProps } from "vue";
import { useRouter } from "vue-router";
import SeoScript from "@/client/components/SeoScript/SeoScript.vue";

let dataSearch = {
  area_id: "",
  lp: "",
  selectedDate: "",
  timeStart: "",
  timeEnd: "",
  ts_category_spaces_id: "",
  people_count: "",
  status: "",
  fe: "vn",
  page: 1,
  item_per_page: 10,
  search_sort: "",
  space_id: [622, 4, 623, 28],
};

const item = ref([]);

const getListNearby = async () => {
  try {
    const res = await getListSpaceByLocationApi(dataSearch);
    const list_ids = [622, 4, 623, 28];

    if (res?.data?.data && res?.data?.data?.length) {
      const dataResp = res?.data?.data;
      const idIndexMap = dataResp?.reduce((map, obj, index) => {
        map[obj?.id] = index;
        return map;
      }, {});
      const sortedList = list_ids.map((id) => {
        const index = idIndexMap[id];
        return index !== undefined ? dataResp[index] : null;
      });
      const finalSortedList = sortedList.filter((obj) => obj !== null);

      item.value = finalSortedList;
    } else {
      item.value = [];
    }
  } catch (errors) {
    console.log("recomment errors:", errors);
  } finally {
    store.isLoading = false;
  }
};

onMounted(() => {
  getListNearby();
});

const toast = inject("$toast");

const store = useStore();
const isShowModalSendMail = ref(false);
const isShowModalSendMailMenu = ref(false);
const idSpace = ref(69);
const displayId = ref(10126);
const inforSpace = ref({});
const inforDisplay = ref({});
const currentModalId = ref(null);
const accsess = ref({
  post_code: "",
  address: "",
});
const listDataAccessStations = ref();
const isShowModalImg = ref(false);
const fristImageFacilityId = ref();
const dataCatering = ref();
const isShowModalPlan = ref(false);
const dataTopMovie = ref([
  {
    img_pc: PC_TOP_OPEN,
    img_mobile: SP_TOP_OPEN,
  },
]);

onMounted(() => {
  const carouselBtn = document.querySelectorAll(".carousel__pagination-button");
  carouselBtn.forEach((e) => {
    const dotNode = document.createElement("span");
    dotNode.classList.add("carousel__pagination-button-dot");
    e.appendChild(dotNode);
  });
});

const handleShowModalMenu = () => {
  isShowModalSendMailMenu.value = true;
};
const handleShowModalDetail = () => {
  isShowModalPlan.value = false;
  setTimeout(function () {
    isShowModalSendMail.value = true;
  }, 300);
};
const openModalPlan = (id) => {
  currentModalId.value = id;
  isShowModalPlan.value = true;
};
const closeModalPlan = () => {
  isShowModalPlan.value = false;
};
const mapSrc = ref("");
const handleGetManageSpace = async (id) => {
  try {
    store.isLoading = true;
    const res = await getListDetailSpaceApi(id);
    if (res.data) {
      inforSpace.value = res.data;
      accsess.value.post_code =
        inforSpace.value?.general.general_location_post_code;
      accsess.value.address =
        inforSpace.value?.general.general_location_prefecture +
        inforSpace.value.general.general_location_municipality +
        inforSpace.value?.general.general_location_address_ja;
      listDataAccessStations.value =
        inforSpace.value?.general?.general_acccess_from_stations;
      const latitude = res.data?.general?.general_location_latitude;
      const longitude = res.data?.general?.general_location_longitude;
      if (latitude && longitude) {
        mapSrc.value = `https://maps.google.co.jp/maps?q=${latitude},${longitude}&z=18&output=embed&iwloc=J&t=m&hl=ja`;
      } else {
        console.error("Latitude and Longitude are not defined.");
      }
    }
  } catch (error) {
    toast.error(error.message);
  } finally {
    store.isLoading = false;
  }
};

const fetchInfoSpaceData = async () => {
  try {
    store.isLoading = true;
    const res = await getSpaceInfoByDisplayIdApi(displayId.value);
    if (res) {
      idSpace.value = res?.id;
      inforDisplay.value = res;
    }
    if (idSpace.value) {
      await handleGetManageSpace(idSpace.value);
    }
  } catch (error) {
    toast.error(error.message);
  } finally {
    store.isLoading = false;
  }
};

let isMobile = window.innerWidth <= 490;

const handleClickNavItem = () => {
  isShowNavbar.value = false;
  const scroll = document.getElementsByTagName("html");
  scroll[0].classList.remove("htmlNoScroll");
  document.removeEventListener("click", handleClickOutside, true);
};
const handleClickReservation = () => {
  isShowNavbar.value = false;
  isShowReservation.value = !isShowReservation.value;
  const scroll = document.getElementsByTagName("html");

  if (isShowReservation.value) {
    scroll[0].classList.add("htmlNoScroll");
    if (!isMobile) {
      document.addEventListener("click", handleClickOutsideReservation, true);
    }
  } else {
    document.removeEventListener("click", handleClickOutsideReservation, true);
    scroll[0].classList.remove("htmlNoScroll");
  }
};
const handleClickMenu = () => {
  isShowReservation.value = false;
  isShowNavbar.value = !isShowNavbar.value;

  const scroll = document.getElementsByTagName("html");
  const navMenu = document.querySelector(".nav-menu");

  if (isShowNavbar.value) {
    scroll[0].classList.add("htmlNoScroll");
    setTimeout(() => {
      if (navMenu) {
        navMenu.scrollTop = 0;
      }
    }, 0);
    if (!isMobile) {
      document.addEventListener("click", handleClickOutside, true);
    }
  } else {
    scroll[0].classList.remove("htmlNoScroll");
    document.removeEventListener("click", handleClickOutside, true);
  }
};

const handleClickOutside = (event) => {
  const navMenu = document.querySelector(".nav-menu");
  const portion = document.querySelector(".lp-gps__group__right");
  if (portion.contains(event.target) && !isMobile) {
    return;
  }
  if (!navMenu.contains(event.target) && !isMobile) {
    event.stopPropagation();
    const scroll = document.getElementsByTagName("html")[0];
    scroll.classList.remove("htmlNoScroll");
    document.removeEventListener("click", handleClickOutside, true);
  }
  if (navMenu && !isMobile) {
    isShowNavbar.value = false;
    const scroll = document.getElementsByTagName("html")[0];
    scroll.classList.remove("htmlNoScroll");
    document.removeEventListener("click", handleClickOutside, true);
  }
};

const handleClickOutsideReservation = (event) => {
  const reservationMenu = document.querySelector(".reservation-menu");
  const portion = document.querySelector(".lp-gps__group__right");
  if (portion.contains(event.target) && !isMobile) {
    return;
  }
  if (!reservationMenu.contains(event.target) && !isMobile) {
    event.stopPropagation();
    const scroll = document.getElementsByTagName("html")[0];
    scroll.classList.remove("htmlNoScroll");
    document.removeEventListener("click", handleClickOutsideReservation, true);
  }

  if (reservationMenu && !isMobile) {
    isShowReservation.value = false;
    const scroll = document.getElementsByTagName("html")[0];
    scroll.classList.remove("htmlNoScroll");
    document.removeEventListener("click", handleClickOutsideReservation, true);
  }
};

const fetchCateringData = async () => {
  try {
    const res = await getCateringDetail();
    if (res) {
      dataCatering.value = res;
    }
  } catch (error) {
    toast.error(error.message);
  } finally {
    store.isLoading = false;
  }
};

onMounted(async () => {
  await fetchInfoSpaceData();
  await fetchCateringData();
});

const handleShowGallery = (facilityId) => {
  fristImageFacilityId.value = facilityId;
  isShowModalImg.value = true;
};

const isShowReservation = ref(false);
const isShowNavbar = ref(false);
const isScroll = ref(false);
const wWidth = ref(0);

const navItem = [
  {
    title: "トップ",
    href: "#",
  },
  {
    title: "フォトギャラリー",
    href: "#gallery",
  },
  {
    title: "価格",
    href: "#price",
  },
  {
    title: "ご利用スタイル",
    href: "#type-use",
  },
  {
    title: "お客様に選ばれる理由",
    href: "#reason",
  },
  {
    title: "ケータリングプラン",
    href: "#serve",
  },
  {
    title: "アクセス",
    href: "#access",
  },
  {
    title: "レンタルスペース詳細",
    href: "#lp-overview",
  },
  {
    title: "タイムシェアリング for Party にもどる",
    href:
      window.location.protocol + "//" + window.location.hostname + "/forparty",
  },
  {
    title: "タイムシェアリングへ戻る",
    href: window.location.protocol + "//" + window.location.hostname,
  },
];

const galeryBreakpoints = {
  200: {
    itemsToShow: 1,
    snapAlign: "center",
    itemsToScroll: 1,
    modelValue: 0,
    autoplay: 5000,
  },
  768: {
    itemsToShow: 1.4,
    snapAlign: "start",
    itemsToScroll: 1,
    modelValue: 0,
    autoplay: 5000,
  },
  880: {
    itemsToShow: 2,
    snapAlign: "start",
    itemsToScroll: 1,
    modelValue: 0,
    autoplay: 5000,
  },
  1280: {
    itemsToShow: 2.6,
    snapAlign: "start",
    itemsToScroll: 1,
    modelValue: 0,
    autoplay: 5000,
  },
  1480: {
    itemsToShow: 3.2,
    snapAlign: "start",
    itemsToScroll: 1,
    modelValue: 0,
    autoplay: 5000,
  },
  1600: {
    itemsToShow: 3.4,
    snapAlign: "start",
    itemsToScroll: 1,
    modelValue: 0,
    autoplay: 5000,
  },
  1920: {
    itemsToShow: 3.6,
    snapAlign: "start",
    itemsToScroll: 1,
    modelValue: 0,
    autoplay: 5000,
  },
};

onUnmounted(() => {
  const scroll = document.getElementsByTagName("html");
  scroll[0].classList.remove("htmlNoScroll");
});

onMounted(() => {
  const scrollMenu = document.getElementsByClassName("nav-menu-show");
  scrollMenu.scrollTop = 0;
});

watch(() => {
  window.scrollTo({ top: 0, behavior: "smooth" });
});

window.onscroll = () => {
  if (window.innerWidth > 767) {
    if (window.scrollY >= 1000) {
      isScroll.value = true;
    } else {
      isScroll.value = false;
    }
  } else {
    if (window.scrollY >= 500) {
      isScroll.value = true;
    } else {
      isScroll.value = false;
    }
  }
};

const carouselBreakpoints = ref({
  300: {
    itemsToShow: 1.23,
    snapAlign: "start",
  },
  768: {
    itemsToShow: 2.3,
    snapAlign: "start",
  },
  1024: {
    itemsToShow: 3,
    snapAlign: "start",
  },
});

const planBreakpoints = ref({
  300: {
    snapAlign: "center",
    itemsToScroll: 1,
    itemsToShow: 1.2,
  },
  768: {
    snapAlign: "start",
    itemsToScroll: 1,
    itemsToShow: 2,
  },
  1024: {
    snapAlign: "start",
    itemsToScroll: 1,
    itemsToShow: 3,
  },
  1480: {
    snapAlign: "start",
    itemsToScroll: 1,
    itemsToShow: 3,
  },
  1920: {
    snapAlign: "start",
    itemsToScroll: 1,
    itemsToShow: 3.6,
  },
});

const router = useRouter();
const props = defineProps({
  linkClass: {
    type: String,
    default: () => "sky-blue",
  },
  linkLst: {
    type: Array,
    default: () => [
      {
        link: "/",
        page_title: "タイムシェアリング",
      },
      {
        link: "/forparty",
        page_title: "パーティー会場",
      },
      {
        page_title: "グレイドパーク新宿",
      },
    ],
  },
});
const handlePagelink = (url) => {
  router.push(url);
};
</script>

<style lang="scss" scoped>
@import "@/client/views/BusinessAccount/Components/BusinessBreadcrumbs/BusinessBreadcrumbs.scss";
</style>